import * as React from "react";
import { Participant } from "twilio-video";
// import { ParticipantInfo } from "./ParticipantInfo";
import { ParticipantTracks } from "./ParticipantTracks";

interface Props {
	participant: Participant;
}
export const AdminContainer = ({ participant }: Props) => {
	return <ParticipantTracks isLocalParticipant={false} participant={participant} />;
};
